function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { getTmsInstance } from "integration-web-core--socle/js/assets/commons/_tms";
import Layer from '@mozaic-ds/freemarker/js/modules/_layer.js';
var AddToShoppingList = /*#__PURE__*/function (_lm$Composant) {
  function AddToShoppingList(id) {
    var _this;
    _classCallCheck(this, AddToShoppingList);
    _this = _callSuper(this, AddToShoppingList, [id]);
    _this.PARAMS = {
      OPEN_LAYER: 'isOpenShoppinglistPopin',
      QUANTITY: 'withQuantity'
    };
    _this.quantity = 1;
    _this.button = document.querySelector(".js-shopping-list-button");
    try {
      var offerFormElement = document.querySelector("form.js-add-to-cart-pdp-form");
      if (offerFormElement) {
        _this.refLm = offerFormElement.querySelector("input[name='reflm']").value;
        _this.offerId = offerFormElement.querySelector("input[name='offerId']").value;
        _this.quantitySelectorElement = offerFormElement.querySelector("input[name='quantity']");
      }
    } catch (error) {
      throw new Error(error);
    }
    _this.button.addEventListener('click', function (e) {
      return _this.addParamsToReferer(e);
    });
    if (window.location.search.includes(_this.PARAMS.QUANTITY)) {
      var searchParams = new URLSearchParams(window.location.search);
      _this.quantity = searchParams.get(_this.PARAMS.QUANTITY);
    }
    if (_this.button && !!window.location.search.includes("".concat(_this.PARAMS.OPEN_LAYER, "=true"))) {
      var _window$addtoshopping, _window$addtoshopping2;
      _this.selectListModal = new Layer({
        "classContent": "js-select-list-modal"
      });
      _this.selectListModal.content = _this.selectListModal.layer.querySelector('.mc-layer__body');
      _this.selectListModal.button = _this.selectListModal.layer.querySelector('.js-select-list-modal-button');
      _this.resultModal = new Layer({
        "classContent": "js-result-modal"
      });
      _this.resultModal.content = _this.resultModal.layer.querySelector('.mc-layer__body');
      _this.errorMessage = (_window$addtoshopping = (_window$addtoshopping2 = window.addtoshoppinglist) === null || _window$addtoshopping2 === void 0 || (_window$addtoshopping2 = _window$addtoshopping2.translation) === null || _window$addtoshopping2 === void 0 ? void 0 : _window$addtoshopping2.errorText) !== null && _window$addtoshopping !== void 0 ? _window$addtoshopping : "Unknown error occurred";
      _this.getShoppingList();
    }
    return _this;
  }

  /**
  * Edit href button to add params
  */
  _inherits(AddToShoppingList, _lm$Composant);
  return _createClass(AddToShoppingList, [{
    key: "addParamsToReferer",
    value: function addParamsToReferer(e) {
      e.preventDefault();
      var url = new URL(this.button.formAction);
      var refererValue = url.searchParams.get('referer');
      refererValue += encodeURI("?".concat(this.PARAMS.OPEN_LAYER, "=true"));
      if (this.quantitySelectorElement) {
        refererValue += encodeURI("&".concat(this.PARAMS.QUANTITY, "=").concat(this.quantitySelectorElement.value));
      }
      url.searchParams.set('referer', refererValue);
      window.location = url;
    }

    /**
     * HTTP request to retrieve existing shopping lists
     */
  }, {
    key: "getShoppingList",
    value: function getShoppingList() {
      var _this2 = this;
      lm.fetch({
        url: "/shoppinglist/services/list",
        method: "GET",
        headers: new Headers({
          "referer": window.document.location,
          "Content-Type": "application/json;charset=UTF-8"
        }),
        success: function success(response) {
          _this2.selectListModal.content.innerHTML = response;
          var el = _this2.selectListModal.layer.querySelector('.js-select-list-modal-radio input[type="radio"]:checked');
          _this2.radiosRules(el);
          _this2.watchFormChanges();
        },
        error: function error(_error) {
          _this2.selectListModal.content.innerHTML = _this2.errorMessage;
          console.error(_error);
        },
        complete: function complete() {
          _this2.selectListModal.open();
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      });
    }
  }, {
    key: "radiosRules",
    value: function radiosRules(el) {
      this.selectListModal.radios = this.selectListModal.layer.querySelectorAll('.js-select-list-modal-radio input[type="radio"]');
      this.selectListModal.input = this.selectListModal.layer.querySelector('.js-select-list-modal-input');
      this.selectListModal.listName = this.selectListModal.layer.querySelectorAll('.js-select-list-modal-radio label');
      this.selectListModal.errorMsg = this.selectListModal.layer.querySelector('.js-error-same-name');
      if (el.target === this.selectListModal.radios[this.selectListModal.radios.length - 1]) {
        this.isNewList = true;
        this.selectListModal.input.focus();
        this.selectListModal.button.disabled = this.selectListModal.input.value.length === 0;
        this.listId = null;
      } else {
        this.isNewList = false;
        this.selectListModal.input.value = "";
        this.selectListModal.button.disabled = _toConsumableArray(this.selectListModal.radios).filter(function (radio) {
          return radio.checked;
        }).length === 0;
        this.listId = _toConsumableArray(this.selectListModal.radios).find(function (radio) {
          return radio.checked;
        }).value;
        this.listName = null;
      }
    }

    /**
     * Look at the changes on the form to determine if we are in the case of
     * a choice of an existing list or if we need to create a new shopping list
     * @return void
     */
  }, {
    key: "watchFormChanges",
    value: function watchFormChanges() {
      var _this3 = this;
      var lists = _toConsumableArray(this.selectListModal.listName).map(function (o) {
        return o.innerHTML.trim();
      });
      this.selectListModal.radios.forEach(function (radio) {
        radio.addEventListener("change", function (el) {
          return _this3.radiosRules(el);
        });
      });
      this.selectListModal.input.addEventListener("keyup", function () {
        _this3.isNewList = true;
        _this3.selectListModal.radios[_this3.selectListModal.radios.length - 1].checked = true;
        _this3.selectListModal.button.disabled = _this3.selectListModal.input.value.length === 0;
        _this3.listName = _this3.selectListModal.input.value;
        _this3.selectListModal.errorMsg.classList.toggle('kl-hidden', !lists.includes(_this3.listName));
        _this3.selectListModal.input.classList.toggle('is-invalid', lists.includes(_this3.listName));
        _this3.selectListModal.button.disabled = lists.includes(_this3.listName);
        _this3.listId = null;
      });
      this.selectListModal.button.addEventListener("click", function () {
        return _this3.prepareDataAndSend();
      });
    }

    /**
     * preparation of the body before sending to the post
     */
  }, {
    key: "prepareDataAndSend",
    value: function prepareDataAndSend() {
      var data = {
        'listId': this.listId,
        'listName': this.listName,
        'product': {
          'refLm': this.refLm,
          'quantity': this.quantity,
          'offerId': this.offerId
        }
      };
      this.postProductInShoppingList(data);
    }

    /**
     * Adding a product to a shopping list
     * @param  {data: object} data - body for post with refLm / quantity / listId (add in existing list) or listname (for create a new list)
     */
  }, {
    key: "postProductInShoppingList",
    value: function postProductInShoppingList(data) {
      var _this4 = this;
      lm.fetch({
        url: "/shoppinglist/services/addProduct",
        method: "POST",
        headers: new Headers({
          "referer": window.document.location,
          "Content-Type": "application/json;charset=UTF-8"
        }),
        body: JSON.stringify(data),
        success: function success(result) {
          _this4.resultModal.content.innerHTML = result;
          _this4.resultModal.layer.querySelector(".js-layer-first-cta").href = _this4.resultModal.content.querySelector("input[name='listUrl']").value;
          lm.lazyload.observe();
          if (data.listName && data.listName !== "") {
            _this4.trackNewShoppingList();
          } else {
            _this4.trackAddProductInShoppingList();
          }
        },
        error: function error(_error2) {
          _this4.resultModal.content.innerHTML = _this4.errorMessage;
          console.error(_error2);
        },
        complete: function complete() {
          return _this4.resultModal.open();
        }
      });
    }

    /**
     * Sending a tracking event when creating a new shopping list
     */
  }, {
    key: "trackNewShoppingList",
    value: function trackNewShoppingList() {
      getTmsInstance().pushEvent(this.selectListModal.button, 'cdl_event', {
        'event_name': 'product.add_to_wishlist',
        'event_data': {
          'product_id': this.refLm,
          'wishlist_isdefault': false
        }
      });
      getTmsInstance().pushEvent(this.selectListModal.button, 'cdl_event', {
        'event_name': 'wishlist.creation',
        'event_data': {
          'wishlist_creation_method': 'pdp',
          'wishlist_isdefault': false
        }
      });
    }

    /**
     * Sending a tracking event when adding a product to an existing shopping list
     */
  }, {
    key: "trackAddProductInShoppingList",
    value: function trackAddProductInShoppingList() {
      getTmsInstance().pushEvent(this.selectListModal.button, 'cdl_event', {
        'event_name': 'product.add_to_wishlist',
        'event_data': {
          'product_id': this.refLm,
          'wishlist_isdefault': true
        }
      });
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  new AddToShoppingList("addtoshoppinglist");
});